import { useCurrentWorkspace } from '@gripp/shared-logic';
import { SlideAction, SlideLayout, Spacing, ViewMode } from '@gripp/shared-ui';
import { useRef, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useNavigate, useParams } from 'react-router-dom';
import ActivityEditLabels from '../../activity/components/activity-edit-label';
import { NewIssueBody } from '../../issues';
import { HeaderResetButton } from '../../shared/components/headerResetButton';
import { useAssetRouting } from '../assetRouteContext';
import { AssetCard } from './assetCard';
import { AssetFilters } from './assetFilters';

export const AssetNewIssue = () => {
  const { assetId = '' } = useParams();
  const navigate = useNavigate();
  const { basePath } = useAssetRouting(assetId);
  const [selectedLabels, setSelectedLabels] = useState<
    Array<{ id: string; name: string }>
  >([]);
  const [isLabelsPanelOpen, setIsLabelsPanelOpen] = useState(false);
  const currentWorkspace = useCurrentWorkspace();
  const resetLabelsRef = useRef<(() => void) | undefined>(undefined);

  const leftColumn = {
    title: 'assets.menu.title',
    mainComponent: <AssetCard assetId={assetId} />,
    headerComponent: <AssetFilters assetId={assetId} />,
    showBackButton: true,
    backButtonTransition: SlideAction.PREV,
    onBackButtonPress: () => {
      navigate(basePath);
    },
  };

  const rightColumn = {
    title: 'issue.new.addIt',
    mainComponent: (
      <NewIssueBody
        assetId={assetId}
        workspaceId={currentWorkspace?.id}
        isOpened={true}
        modalType="sheet"
        onComplete={() => navigate(basePath)}
        onCancel={() => navigate(basePath)}
        onIssueCreated={(issueId) =>
          navigate(`${basePath}/activities/${issueId}`)
        }
        selectedLabels={selectedLabels}
        onLabelsChange={setSelectedLabels}
        onSelectorEdit={() => setIsLabelsPanelOpen(true)}
      />
    ),
    showBackButton: true,
    backButtonTransition: SlideAction.PREV,
    onBackButtonPress: () => {
      navigate(basePath);
    },
    disableScroll: true,
  };

  const thirdColumn = isLabelsPanelOpen
    ? {
        title: 'asset.groups',
        mainComponent: (
          <ActivityEditLabels
            selectedLabels={selectedLabels ?? []}
            onLabelsChange={setSelectedLabels}
            resetRef={resetLabelsRef}
          />
        ),
        headerComponent: (
          <View style={styles.headerResetButton}>
            <HeaderResetButton onReset={() => resetLabelsRef.current?.()} />
          </View>
        ),
        showBackButton: true,
        disableScroll: true,
        onBackButtonPress: () => setIsLabelsPanelOpen(false),
      }
    : undefined;

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      thirdColumn={thirdColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainer: {
    flex: 1,
    paddingHorizontal: Spacing.basePadding.paddingHorizontal,
    paddingVertical: Spacing.basePadding.paddingVertical,
  },
  headerResetButton: {
    marginRight: 8,
  },
});
